export const commercialTemplates = [
  {
    key: 'asset_maintenance',
    label: 'Asset Maintenance',
    description:
      'For organizations managing inspections, preventive maintenance, downtime, and repair history for owned or managed assets.',
    modules: ['Work Orders', 'Assets', 'Technicians', 'Scheduling', 'Preventive Maintenance', 'Reports', 'Audit Log'],
  },
  {
    key: 'service_dispatch',
    label: 'Service Dispatch',
    description:
      'For service businesses dispatching technicians to customers, sites, and incoming service requests.',
    modules: ['Work Orders', 'Customers', 'Technicians', 'Dispatch', 'Scheduling', 'Reports', 'Audit Log'],
  },
  {
    key: 'hybrid_operations',
    label: 'Hybrid Operations',
    description:
      'For companies that manage both owned assets and customer-facing service work in a single operating model.',
    modules: ['Work Orders', 'Assets', 'Customers', 'Technicians', 'Dispatch', 'Preventive Maintenance', 'Scheduling', 'Reports', 'Audit Log'],
  },
];
